import { Link } from 'react-router-dom';
import { brandInfo, footerLogo, socialLinks } from '@/mocks/homeData';

const quickLinks = [
  { id: 'about', label: 'About Us', to: '/about' },
  { id: 'certificates', label: 'Certifications', to: '/about#certificates' },
  { id: 'categories', label: 'Product Range', to: '/products' },
  { id: 'medicines', label: 'Our Medicines', to: '/products' },
  { id: 'network', label: 'Our Network', to: '/#network' },
  { id: 'distributor', label: 'Become a Distributor', to: '/#distributor-apply' },
  { id: 'contact', label: 'Contact Us', to: '/contact' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-10 py-12 md:py-16">
          <div className="lg:col-span-4">
            <Link
              to="/"
              aria-label="Best Research Pharma home"
              className="inline-flex items-center rounded-lg bg-background-50 px-4 py-2.5 cursor-pointer"
            >
              <img
                src={footerLogo}
                alt="Best Research Pharma logo"
                title="Best Research Pharma - Ayurvedic Medicine Manufacturers"
                className="h-11 md:h-14 w-auto object-contain"
              />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-sm">
              A leading Ayurvedic medicine manufacturer and supplier from Madurai, Tamil Nadu, crafting authentic
              herbal formulations for health and wellness across India.
            </p>
            <div className="flex items-center gap-2 mt-5">
              {socialLinks.map((item) => (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  title={item.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800/70 text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50 uppercase tracking-[0.14em]">
              Quick Links
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <h4 className="font-heading text-sm font-semibold text-background-50 uppercase tracking-[0.14em]">
              Reach Us
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-100/80">
              <li className="flex gap-3">
                <i className="ri-map-pin-2-line text-accent-300 mt-0.5 shrink-0"></i>
                <span>{brandInfo.addressLines.join(' ')}</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-phone-fill text-accent-300 mt-0.5 shrink-0"></i>
                <span className="flex flex-col gap-0.5">
                  <a
                    href={`tel:${brandInfo.phoneSecondary.replace(/\s/g, '')}`}
                    className="hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {brandInfo.phoneSecondary}
                  </a>
                  <a
                    href={`tel:${brandInfo.phoneThird.replace(/\s/g, '')}`}
                    className="hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {brandInfo.phoneThird}
                  </a>
                </span>
              </li>
              <li className="flex gap-3">
                <i className="ri-mail-line text-accent-300 mt-0.5 shrink-0"></i>
                <a
                  href={`mailto:${brandInfo.email}`}
                  className="hover:text-accent-300 transition-colors cursor-pointer break-all"
                >
                  {brandInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-700/60 pt-5 pb-16 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>&copy; {new Date().getFullYear()} Best Research Pharma. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Manufactured with care in Madurai, Tamil Nadu
            <i className="ri-heart-fill text-accent-400"></i>
          </p>
          <p className="flex items-center gap-1">
            Website by <span className="font-semibold text-accent-300">DHAHA MOHAMED</span>
          </p>
        </div>
      </div>
    </footer>
  );
}